const getters = {
    websitebuildersId: (state) => state.websitebuildersId,
    website: (state) => state.website,
    loading: state => state.loading
};

export default getters;